import './bootstrap';

// Externals
import './wwdev/bootstrap/index.js';
import './wwdev/cookiebar/index';
import './wwdev/forms/index';
import '@fancyapps/fancybox';
$.fancybox.defaults.hash = false;
import './wwdev/webshop/index.js';
import '@wwdev/myaccount/corporateFields';
import '@wwdev/register';
import '@wwdev/search';
import './externals/hamburgers.js';
import './externals/flickity';
import '@solundo/webshop'
import '@solundo/account';
import '@solundo/image-ai';
import './externals/youtube';

// Vendors
import './vendor/Contentable/overview.js';
import './SearchRequest';

// Sections
import './sections/OfferteFormulier';

// Base
import './base/header';
import './base/DynamicHeight';
import './base/InfoTab.js';
import './indicator';

import './externals/animate';
import './components/advice';
